module.exports = __webpack_public_path__ + "fonts/inter-v2-latin-regular.woff?41e86578ed11f2de28bc5e90b5b322f2";